import { To, useNavigate } from 'react-router-dom';

const useNavigationController = () => {
  const navigate = useNavigate();

  const onNavigation = (to: To) => {
    navigate(to);
  };

  return {
    onNavigation,
  };
};

export default useNavigationController;
